export default __webpack_public_path__ + "media/images/icons/inverse-x-gray-lighter-solid-529acac4b9df74bfa2d128b4df1635fa.svg";